<template>
  <v-list height="auto">
    <v-list-item-group class="mt-2">
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.VehicleLabel}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['vehicleLabel'] }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.Label}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['label'] }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.VehicleType}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['vehicleType'] }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.manufacturer}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['manufacturer'] }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.DriverName}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['driverName'] }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.Speed}}</v-list-item-title>
        <v-list-item-subtitle
          class="text-caption font-weight-regular"
        >{{ tabData['speed']+" km/h" }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.TotalMileage}}</v-list-item-title>
        <v-list-item-subtitle
          class="text-caption font-weight-regular"
        >{{ tabData['totalMileage']+" km" }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">Danas km:</v-list-item-title>
        <v-list-item-subtitle
          class="text-caption font-weight-regular"
        >{{ tabData['todayKillometers']+" km" }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.CurrentLocation}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData['currentLocation'] ? tabData['currentLocation'] : '/'  }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-caption font-weight-bold">{{labels.LastMeasuredAt}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption font-weight-regular">
          {{convertDate(tabData['packetTimestamp'], true)}}
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <template v-if="tabData.speed>0">
          <v-list-item-title class="text-caption font-weight-bold">{{labels.StartMoving}}</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{convertDate(tabData['movedAt'], true)}}</v-list-item-subtitle>
        </template>
        <template v-else>
          <v-list-item-title class="text-caption font-weight-bold">{{labels.startStanding}}</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular"> {{convertDate(tabData['stoppedAt'], true)}}</v-list-item-subtitle>
        </template>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
export default {
  props: {
    tabData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      labels: {
        VehicleLabel: translate('Vehicle Label', 'realtimeMap'),
        Imei: translate('Imei', 'realtimeMap'),
        VehicleType: translate('Vehicle Type', 'realtimeMap'),
        DriverName: translate('Driver Name', 'realtimeMap'),
        Speed: translate('Speed', 'realtimeMap'),
        TotalMileage: translate('Total Mileage', 'realtimeMap'),
        MileageToday: translate('Mileage Today'),
        CurrentLocation: translate('Current location', 'realtimeMap'),
        LastMeasuredAt: translate('Last Measured At', 'realtimeMap'),
        StartMoving: translate('Start moving', 'realtimeMap'),
        startStanding: translate('Start standing', 'realtimeMap'),
        manufacturer: translate('Manufacturer', 'fields.vehicles'),
        Label: translate('Label', 'realtimeMap')
      }
    }
  },
  methods: {
    convertDate(date, uct = false) {
      if (!date) {
        return '/'
      }
      if (date.indexOf('+') != -1) {
        return formatDate(date.split('+')[0], 'long', true)
      }

      if (date.indexOf('Z') != -1) {
        return formatDate(date.split('Z')[0], 'long', true)
      }
      return formatDate(date, 'long', uct)
    }
  }
}
</script>
<style scoped>
.v-list-item {
  min-height: 22px;
}
</style>
